export default "__VITE_ASSET__gdwC3kpC__";